(function () {
  let offsetObserver;

  // A pinned bar is always fully visible: its height is the offset for everything stuck under it
  // (header, PDP page menu, anchor scroll margins). Measured, because the text can wrap.
  const observeStickyOffset = (annBar) => {
    if (offsetObserver) offsetObserver.disconnect();
    const root = document.documentElement;
    const isSticky = Boolean(annBar?.querySelector("[data-announcement-sticky]"));

    if (!isSticky) {
      root.style.setProperty("--announcement-bar-offset", "0px");
      return;
    }

    offsetObserver = new ResizeObserver(() => {
      const height = `${annBar.getBoundingClientRect().height.toFixed(2)}px`;
      root.style.setProperty("--announcement-bar-offset", height);
      // The intersection ratio of a pinned bar never changes, so the observer below misses resizes.
      root.style.setProperty("--ann-height", height);
    });
    offsetObserver.observe(annBar);
  };

  const initAnnBar = () => {
    const annBar = document.querySelector(".section-announcement");
    observeStickyOffset(annBar);

    let observer;
    const createObserver = () => {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const annBarHeight = annBar?.getBoundingClientRect().height || 0;
              document.documentElement.style.setProperty(
                "--ann-height",
                `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
              );
            } else {
              document.documentElement.style.setProperty("--ann-height", "0px");
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      if (annBar) observer.observe(annBar);
    };
    createObserver();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
